import React from "react";
import styles from "./Contact.module.css";
import ContactBanner from "../../assets/parli.png";
import svg from "../../assets/svg";
import PageHeader from "../../ReusableComponents/PageHeader/PageHeader";
import Reveal from "../../ReusableComponents/Reveal/Reveal";

/* Values are kept exactly as they were published; only the labels are new. */
const CHANNELS = [
  {
    label: "Helpline",
    value: "18001239017",
    href: "tel:18001239017",
    icon: svg.callIcon,
  },
  {
    label: "Helpline",
    value: "18005479017",
    href: "tel:18005479017",
    icon: svg.callIcon,
  },
  {
    label: "Mobile",
    value: "+91 8489925481",
    href: "tel:+918489925481",
    icon: svg.callIcon,
  },
  {
    label: "Email",
    value: "joinjcmmakkalmandram@gmail.com",
    href: "mailto:joinjcmmakkalmandram@gmail.com",
    icon: svg.emailIcon,
  },
];

/* The Facebook entry used svg.facebookIcon, which does not exist in svg.js -
   the link rendered with no icon at all. The key is fbIcon. */
const CHANNELS_SOCIAL = [
  { label: "Facebook", href: "https://facebook.com/ljk.puducherry", icon: svg.fbIcon },
  // { label: "Facebook", href: "https://www.facebook.com/JCMmakkalmandram", icon: svg.fbIcon },
  { label: "X", href: "https://x.com/ljk_puducherry", icon: svg.twitterIcon },
  {
    label: "Instagram",
    // href: "https://www.instagram.com/jcmmakkalmandram?igsh=MWIxczZhdD45ZWY4Zg==",
    href: "https://instagram.com/ljk_puducherry",
    icon: svg.instaIcon,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@ljkpuducherry",
    icon: svg.youtubeIcon,
  },
  {
    label: "WhatsApp",
    // href: "https://whatsapp.com/channel/0029VbAq7GzGehEGyv6kUK2d",
    href: "https://whatsapp.com/channel/0029Vb7AlHr3QxS4Kw7XzE2L",
    icon: svg.wIcon,
  },
];

const Contact = () => {
  return (
    <main className={styles.contactContainer}>
      <PageHeader
        eyebrow="Get in touch"
        title="Contact Us"
        image={ContactBanner}
      />

      <section className={styles.contentSection}>
        <Reveal className={styles.intro} y={24}>
          <h2 className={styles.introTitle}>Reach the team</h2>
          <p className={styles.introText}>
            Call a helpline, send a message, or follow along on the channels
            below — whichever suits you.
          </p>
        </Reveal>

        <Reveal
          className={styles.channels}
          selector="[data-channel]"
          stagger={0.08}
          y={28}
        >
          {CHANNELS.map((channel) => (
            <a
              key={`${channel.label}-${channel.value}`}
              className={styles.channel}
              href={channel.href}
              data-channel
            >
              <span className={styles.channelIcon}>{channel.icon}</span>
              <span className={styles.channelBody}>
                <span className={styles.channelLabel}>{channel.label}</span>
                <span className={styles.channelValue}>{channel.value}</span>
              </span>
              <svg className={styles.channelArrow} viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M3 8h9M8.5 4l4 4-4 4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          ))}
        </Reveal>

        <Reveal className={styles.socialPanel} y={28}>
          <div className={styles.socialCopy}>
            <h3 className={styles.socialTitle}>Follow us</h3>
            <p className={styles.socialText}>
              Updates, events and announcements as they happen.
            </p>
          </div>

          <div className={styles.socialLinks}>
            {CHANNELS_SOCIAL.map((social) => (
              <a
                key={social.label}
                className={styles.social}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </Reveal>
      </section>
    </main>
  );
};

export default Contact;
